import AUTHOR_QUERY from "@pathwright/web/src/modules/author/graphql/author-query"
import CATEGORY_QUERY from "@pathwright/web/src/modules/category/graphql/category-query"
import { getApolloClient } from "@pathwright/web/src/modules/pathwright/PathwrightClient"
import { encodeQueryParams } from "@pathwright/web/src/modules/utils/useControlledQueryParams"
import get from "lodash/get"
import StoreOrLibraryBrowse from "../store/StoreOrLibraryBrowse"

export default {
  path: "/library/:by(by)?/:facet(category|author)?/:facetValue?/",
  component: StoreOrLibraryBrowse,
  // handle legacy by/author|category/*/ routes by querying for the author/cateogry by slug then redirecting to new route that expects author/category names
  onEnter: async (nextState, replaceState, callback) => {
    if (!nextState.match.params.facet) return callback()
    if (nextState.match.params.facetValue === "all")
      return callback(
        replaceState({
          pathname: "/library/"
        })
      )

    let facetName = null

    const client = getApolloClient(window.school.id)

    switch (nextState.match.params.facet) {
      case "author": {
        const result = await client.query({
          variables: {
            slug: nextState.match.params.facetValue
          },
          query: AUTHOR_QUERY
        })

        facetName = get(result, "data.school.author.full_name")
        break
      }
      case "category": {
        const result = await client.query({
          variables: {
            slug: nextState.match.params.facetValue
          },
          query: CATEGORY_QUERY
        })
        facetName = get(result, "data.school.category.name")
        break
      }
    }

    if (facetName) {
      // found a facet name to redirect to, handle it
      const searchParams = encodeQueryParams({
        [nextState.match.params.facet]: [facetName]
      })

      return callback(
        replaceState({
          pathname: "/library/",
          search: searchParams
        })
      )
    }
  }
}
